import { memo } from 'react';
import { View } from 'react-native';
import { FeedThreadRowSkeleton } from './FeedThreadRowSkeleton';

/** Enough to fill a phone; the list's own rows replace them as one. */
const kRowCount = 10;

/**
 * The 通知 list while it loads for the first time: placeholder rows in the
 * real rows' shape, not a spinner in an empty page.
 */
export const FeedThreadListSkeleton = memo(() => (
  <View accessibilityLabel="正在加载通知">
    {Array.from({ length: kRowCount }, (_, i) => (
      <FeedThreadRowSkeleton key={i} wide={i % 2 === 0} />
    ))}
  </View>
));
